<template>
    <stat-layout-card>
        <template #title>
            <h2 class="m-0">{{ data.title }}</h2>
        </template>
        <template #content>
            <ul v-if="items.length > 0" class="m-0">
                <li v-for="(item, itemIndex) in items" :key="itemIndex" ref="products">
                    <a
                        :href="
                            $router.resolve({
                                name: 'legacy.product.overview',
                                params: { id: item.value.id },
                            }).href
                        "
                        class="px-5 py-2 fs-3 hover-primary-05-bkg cpointer flex-level gray-100"
                    >
                        <el-tooltip
                            :content="item.value.name"
                            popper-class="w-320"
                            :disabled="item.disableTooltip"
                        >
                            <div class="ellipsis mr-3">
                                {{ itemIndex + 1 }} - {{ item.value.name }}
                            </div>
                        </el-tooltip>
                        <div class="flex-right gray-60 nowrap">
                            {{ $filters.numberFormat(item.value.total) }} {{ item.unit }}
                        </div>
                    </a>
                </li>
            </ul>
            <div v-else class="acenter">
                <span>{{ $l10n.__('Pas de produits / services vendus pour ce client.') }}</span>
            </div>
        </template>
    </stat-layout-card>
</template>

<script>
import StatLayoutCard from './StatLayoutCard.vue';
export default {
    components: {
        StatLayoutCard,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            items: this.data.slots.items?.slots ? this.data.slots.items?.slots : [],
        };
    },
    mounted() {
        if (this.$refs.products) {
            this.$refs.products.forEach((product, index) => {
                const tooltip = product.getElementsByClassName('el-tooltip')[0];
                this.items[index].disableTooltip = tooltip.scrollWidth <= tooltip.offsetWidth;
            });
            this.$forceUpdate();
        }
    },
};
</script>
